import React, { useState, useEffect } from 'react';
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { db } from "../firebase";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

const Order = () => {
    const [fullName, setFullName] = useState('');
    const [documentType, setDocumentType] = useState('Passport');
    const [documentNumber, setDocumentNumber] = useState('');
    const [nationality, setNationality] = useState('Argentina');
    const [phone, setPhone] = useState('');
    const [bags, setBags] = useState(1);
    const [checkIn, setCheckIn] = useState(new Date());
    const [checkOut, setCheckOut] = useState(() => {
        const date = new Date(Date.now() + 1000 * 60 * 60 * 4);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    });
    const [phoneCode, setPhoneCode] = useState('+54');
    const [email, setEmail] = useState('');
    const [emailTouched, setEmailTouched] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [orderSubmitted, setOrderSubmitted] = useState(false);
    const [orderId, setOrderId] = useState('');
    const [acceptedTerms, setAcceptedTerms] = useState(false);

    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const emailIsValid = isValidEmail(email);

    const increaseBags = () => {
        setBags((prev) => prev + 1);
    };

    const decreaseBags = () => {
        if (bags > 1) {
            setBags((prev) => prev - 1);
        }
    };

    const countryCodes = [
        { country: 'Afghanistan', code: '+93', flag: '🇦🇫' },
        { country: 'Albania', code: '+355', flag: '🇦🇱' },
        { country: 'Algeria', code: '+213', flag: '🇩🇿' },
        { country: 'Andorra', code: '+376', flag: '🇦🇩' },
        { country: 'Angola', code: '+244', flag: '🇦🇴' },
        { country: 'Antigua and Barbuda', code: '+1-268', flag: '🇦🇬' },
        { country: 'Argentina', code: '+54', flag: '🇦🇷' },
        { country: 'Armenia', code: '+374', flag: '🇦🇲' },
        { country: 'Australia', code: '+61', flag: '🇦🇺' },
        { country: 'Austria', code: '+43', flag: '🇦🇹' },
        { country: 'Azerbaijan', code: '+994', flag: '🇦🇿' },
        { country: 'Bahamas', code: '+1-242', flag: '🇧🇸' },
        { country: 'Bahrain', code: '+973', flag: '🇧🇭' },
        { country: 'Bangladesh', code: '+880', flag: '🇧🇩' },
        { country: 'Barbados', code: '+1-246', flag: '🇧🇧' },
        { country: 'Belarus', code: '+375', flag: '🇧🇾' },
        { country: 'Belgium', code: '+32', flag: '🇧🇪' },
        { country: 'Belize', code: '+501', flag: '🇧🇿' },
        { country: 'Benin', code: '+229', flag: '🇧🇯' },
        { country: 'Bhutan', code: '+975', flag: '🇧🇹' },
        { country: 'Bolivia', code: '+591', flag: '🇧🇴' },
        { country: 'Bosnia and Herzegovina', code: '+387', flag: '🇧🇦' },
        { country: 'Botswana', code: '+267', flag: '🇧🇼' },
        { country: 'Brasil', code: '+55', flag: '🇧🇷' },
        { country: 'Brunei', code: '+673', flag: '🇧🇳' },
        { country: 'Bulgaria', code: '+359', flag: '🇧🇬' },
        { country: 'Burkina Faso', code: '+226', flag: '🇧🇫' },
        { country: 'Burundi', code: '+257', flag: '🇧🇮' },
        { country: 'Cambodia', code: '+855', flag: '🇰🇭' },
        { country: 'Cameroon', code: '+237', flag: '🇨🇲' },
        { country: 'Canada', code: '+1', flag: '🇨🇦' },
        { country: 'Chile', code: '+56', flag: '🇨🇱' },
        { country: 'China', code: '+86', flag: '🇨🇳' },
        { country: 'Colombia', code: '+57', flag: '🇨🇴' },
        { country: 'Costa Rica', code: '+506', flag: '🇨🇷' },
        { country: 'Croatia', code: '+385', flag: '🇭🇷' },
        { country: 'Cuba', code: '+53', flag: '🇨🇺' },
        { country: 'Cyprus', code: '+357', flag: '🇨🇾' },
        { country: 'Czech Republic', code: '+420', flag: '🇨🇿' },
        { country: 'Denmark', code: '+45', flag: '🇩🇰' },
        { country: 'Dominican Republic', code: '+1-809', flag: '🇩🇴' },
        { country: 'Ecuador', code: '+593', flag: '🇪🇨' },
        { country: 'Egypt', code: '+20', flag: '🇪🇬' },
        { country: 'El Salvador', code: '+503', flag: '🇸🇻' },
        { country: 'Estonia', code: '+372', flag: '🇪🇪' },
        { country: 'Ethiopia', code: '+251', flag: '🇪🇹' },
        { country: 'Finland', code: '+358', flag: '🇫🇮' },
        { country: 'France', code: '+33', flag: '🇫🇷' },
        { country: 'Georgia', code: '+995', flag: '🇬🇪' },
        { country: 'Germany', code: '+49', flag: '🇩🇪' },
        { country: 'Ghana', code: '+233', flag: '🇬🇭' },
        { country: 'Greece', code: '+30', flag: '🇬🇷' },
        { country: 'Guatemala', code: '+502', flag: '🇬🇹' },
        { country: 'Haiti', code: '+509', flag: '🇭🇹' },
        { country: 'Honduras', code: '+504', flag: '🇭🇳' },
        { country: 'Hungary', code: '+36', flag: '🇭🇺' },
        { country: 'Iceland', code: '+354', flag: '🇮🇸' },
        { country: 'India', code: '+91', flag: '🇮🇳' },
        { country: 'Indonesia', code: '+62', flag: '🇮🇩' },
        { country: 'Iran', code: '+98', flag: '🇮🇷' },
        { country: 'Iraq', code: '+964', flag: '🇮🇶' },
        { country: 'Ireland', code: '+353', flag: '🇮🇪' },
        { country: 'Israel', code: '+972', flag: '🇮🇱' },
        { country: 'Italy', code: '+39', flag: '🇮🇹' },
        { country: 'Jamaica', code: '+1-876', flag: '🇯🇲' },
        { country: 'Japan', code: '+81', flag: '🇯🇵' },
        { country: 'Jordan', code: '+962', flag: '🇯🇴' },
        { country: 'Kazakhstan', code: '+7', flag: '🇰🇿' },
        { country: 'Kenya', code: '+254', flag: '🇰🇪' },
        { country: 'Kuwait', code: '+965', flag: '🇰🇼' },
        { country: 'Kyrgyzstan', code: '+996', flag: '🇰🇬' },
        { country: 'Laos', code: '+856', flag: '🇱🇦' },
        { country: 'Latvia', code: '+371', flag: '🇱🇻' },
        { country: 'Lebanon', code: '+961', flag: '🇱🇧' },
        { country: 'Libya', code: '+218', flag: '🇱🇾' },
        { country: 'Lithuania', code: '+370', flag: '🇱🇹' },
        { country: 'Luxembourg', code: '+352', flag: '🇱🇺' },
        { country: 'Malaysia', code: '+60', flag: '🇲🇾' },
        { country: 'Mexico', code: '+52', flag: '🇲🇽' },
        { country: 'Moldova', code: '+373', flag: '🇲🇩' },
        { country: 'Monaco', code: '+377', flag: '🇲🇨' },
        { country: 'Mongolia', code: '+976', flag: '🇲🇳' },
        { country: 'Morocco', code: '+212', flag: '🇲🇦' },
        { country: 'Nepal', code: '+977', flag: '🇳🇵' },
        { country: 'Netherlands', code: '+31', flag: '🇳🇱' },
        { country: 'New Zealand', code: '+64', flag: '🇳🇿' },
        { country: 'Nicaragua', code: '+505', flag: '🇳🇮' },
        { country: 'Nigeria', code: '+234', flag: '🇳🇬' },
        { country: 'North Korea', code: '+850', flag: '🇰🇵' },
        { country: 'Norway', code: '+47', flag: '🇳🇴' },
        { country: 'Pakistan', code: '+92', flag: '🇵🇰' },
        { country: 'Panama', code: '+507', flag: '🇵🇦' },
        { country: 'Paraguay', code: '+595', flag: '🇵🇾' },
        { country: 'Peru', code: '+51', flag: '🇵🇪' },
        { country: 'Philippines', code: '+63', flag: '🇵🇭' },
        { country: 'Poland', code: '+48', flag: '🇵🇱' },
        { country: 'Portugal', code: '+351', flag: '🇵🇹' },
        { country: 'Qatar', code: '+974', flag: '🇶🇦' },
        { country: 'Romania', code: '+40', flag: '🇷🇴' },
        { country: 'Russia', code: '+7', flag: '🇷🇺' },
        { country: 'Saudi Arabia', code: '+966', flag: '🇸🇦' },
        { country: 'Serbia', code: '+381', flag: '🇷🇸' },
        { country: 'Singapore', code: '+65', flag: '🇸🇬' },
        { country: 'Slovakia', code: '+421', flag: '🇸🇰' },
        { country: 'Slovenia', code: '+386', flag: '🇸🇮' },
        { country: 'South Africa', code: '+27', flag: '🇿🇦' },
        { country: 'South Korea', code: '+82', flag: '🇰🇷' },
        { country: 'Spain', code: '+34', flag: '🇪🇸' },
        { country: 'Sri Lanka', code: '+94', flag: '🇱🇰' },
        { country: 'Sweden', code: '+46', flag: '🇸🇪' },
        { country: 'Switzerland', code: '+41', flag: '🇨🇭' },
        { country: 'Syria', code: '+963', flag: '🇸🇾' },
        { country: 'Taiwan', code: '+886', flag: '🇹🇼' },
        { country: 'Thailand', code: '+66', flag: '🇹🇭' },
        { country: 'Tunisia', code: '+216', flag: '🇹🇳' },
        { country: 'Turkey', code: '+90', flag: '🇹🇷' },
        { country: 'Ukraine', code: '+380', flag: '🇺🇦' },
        { country: 'United Arab Emirates', code: '+971', flag: '🇦🇪' },
        { country: 'United Kingdom', code: '+44', flag: '🇬🇧' },
        { country: 'United States', code: '+1', flag: '🇺🇸' },
        { country: 'Uruguay', code: '+598', flag: '🇺🇾' },
        { country: 'Uzbekistan', code: '+998', flag: '🇺🇿' },
        { country: 'Venezuela', code: '+58', flag: '🇻🇪' },
        { country: 'Vietnam', code: '+84', flag: '🇻🇳' },
        { country: 'Yemen', code: '+967', flag: '🇾🇪' },
        { country: 'Zimbabwe', code: '+263', flag: '🇿🇼' },
    ];

    useEffect(() => {
        const selectedCountry = countryCodes.find(
            (item) => item.country === nationality
        );

        if (selectedCountry) {
            setPhoneCode(selectedCountry.code);
        }
    }, [nationality]);

    const phoneIsValid = phone.trim().length > 0;

    const canSubmit =
        fullName.trim().length > 0 &&
        documentNumber.trim().length > 0 &&
        emailIsValid;

const handleSubmit = async () => {
    if (!canSubmit || isSubmitting) return;
    try {
        setIsSubmitting(true);
        const newOrderId = genCode();
        // 1. CAPTCHA CHECK (Worker)
        const recaptchaToken = await getRecaptchaToken();
        const res = await fetch(
            'https://koffer-email.kofferbagss.workers.dev',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    recaptchaToken,
                    sendEmail: false,
                    email,
                    fullName,
                    orderId: newOrderId,
                    bags,
                    checkIn: checkIn.toLocaleString(),
                    checkOut: checkOut.toLocaleString(),
                }),
            }
        );
        const data = await res.json();
        // console.log("WORKER RESPONSE:", data); // 👈 ВОТ ЭТО ДОБАВЬ
        // ❌ если бот
        if (data.error) {
            throw new Error(data.error);
        }
        // 2. создаём ID
        setOrderId(newOrderId);
        const orderData = {
            orderId: newOrderId,
            status: "Pending",
            fullName,
            documentType,
            documentNumber,
            nationality,
            phoneCode,
            phone,
            email,
            bags,
            checkIn,
            checkOut,
            createdAt: serverTimestamp(),
        };
        // 3. EMAIL
        // await fetch(
        //     'https://koffer-email.kofferbagss.workers.dev',
        //     {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json',
        //         },
        //         body: JSON.stringify({
        //             ...orderData,
        //             checkIn: checkIn.toLocaleString(),
        //             checkOut: checkOut.toLocaleString(),
        //         }),
        //     }
        // );
        // 4. FIRESTORE
        await setDoc(doc(db, "Orders", newOrderId), orderData);
        setOrderSubmitted(true);
    } catch (error) {
        console.error(error);
        setIsSubmitting(false);
    }
};

    function genCode() {
        const d = new Date();
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const r = Math.floor(Math.random() * 9000) + 1000;
        return `KFF-${dd}${mm}-${r}`;
    }

    const isWindows = navigator.userAgent.includes('Windows');

    const getRecaptchaToken = async () => {
    return new Promise((resolve) => {
        window.grecaptcha.ready(async () => {
        const token = await window.grecaptcha.execute(
            "6LeKxO0sAAAAAARlBwI2V6jyNnsr4ihq0TPBd0tY",
            { action: "submit" }
        );
        resolve(token);
        });
    });
    };

    return (
        <div
            className="min-h-screen py-10 px-4 bg-cover bg-center"
            style={{ backgroundImage: "url('/background.jpg')" }}
        >
            <div className="max-w-5xl mx-auto">

                {/* Nombre */}
                <div className="mb-6">
                    <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
                        Full Name *
                    </label>

                    <input
                        type="text"
                        placeholder="Example: John Smith"
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        className={`w-full bg-white border-2 rounded-2xl px-6 py-5 text-2xl outline-none focus:border-[#2e8b57] focus:ring-2 focus:ring-[#2e8b57]/20
                        ${
                            fullName.trim().length > 0
                                ? 'border-green-600'
                                : 'border-[#d8c8bc]'
                        }`}
                    />
                </div>

                {/* Documento */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">

                    <div>
                        <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
                            Document type
                        </label>

                        <select
                            value={documentType}
                            onChange={(e) => setDocumentType(e.target.value)}
                            className="w-full bg-white border border-[#d8c8bc] rounded-2xl px-6 py-5 text-2xl outline-none focus:border-[#2e8b57]"
                        >
                            <option>Passport</option>
                            <option>DNI</option>
                            <option>Other</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
                            Document number *
                        </label>

                        <input
                            type="tel"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            placeholder="12345678"
                            value={documentNumber}
                            onChange={(e) =>
                                setDocumentNumber(
                                    e.target.value.replace(/\D/g, '')
                                )
                            }
                            className={`w-full bg-white border-2 rounded-2xl px-6 py-5 text-2xl outline-none focus:border-[#2e8b57]
                            ${
                                documentNumber.trim().length > 0
                                    ? 'border-green-600'
                                    : 'border-[#d8c8bc]'
                            }`}
                        />
                    </div>
                </div>

                {/* Nacionalidad */}
                <div className="mb-6 max-w-md">
                    <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
                        Nationality
                    </label>

                    <select
                        value={nationality}
                        onChange={(e) => setNationality(e.target.value)}
                        className="w-full bg-white border-4 border-[#2e8b57] rounded-2xl px-6 py-5 text-2xl outline-none"
                    >
                        {countryCodes.map((item) => (
                            <option
                            key={item.country}
                            value={item.country}
                            >
                            {
                            isWindows
                                ? `${item.country}`
                                : `${item.flag} ${item.country}`
                            }
                            </option>
                        ))}
                    </select>
                </div>

                {/* Telefono */}
                <div className="mb-6">
                    <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
                        Telephone number
                    </label>

                    <div className="flex flex-col md:flex-row gap-4">
                        <select
                            value={phoneCode}
                            onChange={(e) => setPhoneCode(e.target.value)}
                            className="bg-[#ebe6e1] rounded-2xl px-6 py-5 text-2xl min-w-[220px] outline-none"
                        >
                            {countryCodes.map((item) => (
                                <option key={item.country} value={item.code}>
                                    {
                                    isWindows
                                        ? `${item.code} (${item.country})`
                                        : `${item.flag} ${item.code} (${item.country})`
                                    }
                                </option>
                            ))}
                        </select>

                        <input
                            type="tel"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            placeholder="11 2345-6789"
                            value={phone}
                            onChange={(e) =>
                                setPhone(
                                    e.target.value.replace(/\D/g, '')
                                )
                            }
                            className={`flex-1 bg-white border-2 rounded-2xl px-6 py-5 text-2xl outline-none focus:border-[#2e8b57]
                            ${
                                phone.trim().length > 0
                                    ? 'border-green-600'
                                    : 'border-[#d8c8bc]'
                            }`}
                        />
                    </div>
                </div>

                {/* Email */}
                <div className="mb-10">
                    <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
                        Email *
                    </label>

                    <input
                        type="email"
                        placeholder="client@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onBlur={() => setEmailTouched(true)}
                        className={`w-full bg-white border-2 rounded-2xl px-6 py-5 text-2xl outline-none transition-colors
                        ${
                            email.length === 0 && !emailTouched
                                ? 'border-[#d8c8bc]'
                                : emailIsValid
                                ? 'border-green-600'
                                : 'border-red-500'
                        }`}
                    />

                    {emailTouched && email.length > 0 && !emailIsValid && (
                        <p className="text-red-500 mt-2 text-sm">
                            Invalid email format
                        </p>
                    )}
                </div>

                {/* Cantidad */}
                <div className="mb-10">
                    <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
                        Number of suitcases
                    </label>

                    <div className="bg-white border border-[#d8c8bc] rounded-2xl w-[260px] px-8 py-5 flex items-center justify-between">
                        <button
                            onClick={decreaseBags}
                            className="text-4xl font-bold text-[#2b1c18]"
                        >
                            −
                        </button>

                        <span className="text-4xl font-bold text-[#2e8b57]">
                            {bags}
                        </span>

                        <button
                            onClick={increaseBags}
                            className="text-4xl font-bold text-[#2b1c18]"
                        >
                            +
                        </button>
                    </div>
                </div>

                {/* Fechas */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                    {/* Check-in */}
                    <div>
                        <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
                            Check-in
                        </label>

                        <div className="bg-white border border-[#d8c8bc] rounded-2xl px-6 py-5">
                            <DateTimePicker
                                onChange={setCheckIn}
                                value={checkIn}
                                disableClock={true}
                                clearIcon={null}
                                calendarIcon={null}
                                format="dd.MM.yyyy, HH:mm"
                                className="koffer-datepicker"
                            />
                        </div>
                    </div>

                    {/* Check-out */}
                    <div>
                        <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
                            Check-out
                        </label>

                        <div className="bg-white border border-[#d8c8bc] rounded-2xl px-6 py-5">
                            <DateTimePicker
                                onChange={setCheckOut}
                                value={checkOut}
                                minDate={checkIn}
                                disableClock={true}
                                clearIcon={null}
                                calendarIcon={null}
                                format="dd.MM.yyyy, HH:mm"
                                className="koffer-datepicker"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {
            orderSubmitted ? (
                <div className="mt-6 bg-[#e8f5ec] border border-[#b7dfc3] rounded-2xl p-5">
                <p className="text-[#2e8b57] font-bold text-2xl">
                    Order ID: {orderId}
                </p>
                <p className="text-[#6b5244] mt-2">
                    Your order is pending confirmation.
                </p>
                </div>
            ) : (
                <div className="mt-10">
                <label className="flex items-start gap-4">
                    <input
                    type="checkbox"
                    checked={acceptedTerms}
                    onChange={(e) => setAcceptedTerms(e.target.checked)}
                    className="mt-1 h-5 w-5 accent-[#2e8b57]"
                    />
                    <span className="text-[#6b5244] leading-7">
                    I agree to the{' '}
                    <a
                        href="/terminos"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-bold text-[#2e8b57] underline hover:text-[#267349]"
                    >
                        Terms & Conditions and Privacy Policy
                    </a>
                    </span>
                </label>
                </div>
            )
            }
            {/* Submit */}
            <div className="mt-10">
                <button
                    onClick={handleSubmit}
                    disabled={
                    !canSubmit ||
                    !acceptedTerms ||
                    isSubmitting ||
                    orderSubmitted
                    }
                    className={`
                        w-full
                        text-white
                        font-bold
                        text-2xl
                        rounded-2xl
                        py-6
                        transition-all
                        shadow-lg
                        mt-10
                        
                        ${
                            !canSubmit
                                ? 'bg-gray-400 cursor-not-allowed shadow-none'
                                : orderSubmitted || isSubmitting || !acceptedTerms
                                ? 'bg-[#9aa09c] cursor-not-allowed shadow-none'
                                : 'bg-[#2e8b57] hover:bg-[#267349] active:scale-[0.99] shadow-[#2e8b57]/20'
                        }
                    `}
                >
                    {
                        orderSubmitted
                            ? 'Done'
                            : isSubmitting
                            ? 'Sending...'
                            : 'Complete order'
                    }
                </button>
            </div>
        </div>
    );
};

export default Order;